(function() {
  'use strict';

  angular
    .module('GPQuery.dashboard', []);

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.dashboard')
    .controller('ResultsController', ResultsController);


  /** @ngInject */
  function ResultsController(ergastService, $log) {
    var vm = this;
    vm.results     = {};
    vm.tableHeaders = [];
    vm.resultsRows  = {};

    activate();

    // Constructor
    // ------------------------------
    function activate() {
      getAll();

    }

    // Mutator Function
    // ------------------------------
    function getAll() {

      ergastService.get().$promise
        .then(function(response) {
          vm.resultsRows = response.MRData.RaceTable.Races[0].Results;
          vm.results = response.MRData;
          $log.info('XHR response success: ' + vm.results);
        }, function(errorMsg) {
          $log.warn('XHR request failed');
          vm.results = errorMsg;
        });

      vm.tableHeaders = ['Pos', 'Grid', 'Driver', '#', 'Nationality', 'Constructor', 'Laps', 'Status', 'Pts'];

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('GPQuery.dashboard')
    .controller('RacesController', RacesController);


  /** @ngInject */
  function RacesController(ergastService, $log) {
    var vm = this;
    vm.results      = {};
    vm.tableHeaders = [];
    vm.resultsRows  = {};

    activate();

    // Constructor
    // ------------------------------
    function activate() {
      getAll();
    }

    // Mutator Function
    // ------------------------------
    function getAll() {
      var params = {
        season    : 'current',
        round     : '',
        resource  : 'races'
      };

      ergastService.getResource(params).$promise
        .then(function(response) {
          vm.resultsRows = response.MRData.RaceTable.Races;
          vm.results = response.MRData;
          $log.info('XHR response success: ' + vm.results);
        }, function(errorMsg) {
          $log.warn('XHR request failed');
          vm.results = errorMsg;
        });

      vm.tableHeaders = ['Rnd', 'Race', 'Circuit', 'Location', 'Date', 'Time'];

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('GPQuery.dashboard')
    .controller('DriversController', DriversController);


  /** @ngInject */
  function DriversController(ergastService, $log) {
    var vm = this;
    vm.results      = {};
    vm.tableHeaders = [];
    vm.resultsRows  = {};

    activate();

    // Constructor
    // ------------------------------
    function activate() {
      getAll();
    }

    // Mutator Function
    // ------------------------------
    function getAll() {
      var params = {
        resource  : 'drivers'
      };

      ergastService.getResource(params).$promise
        .then(function(response) {
          vm.resultsRows = response.MRData.DriverTable.Drivers;
          vm.results = response.MRData;
          $log.info('XHR response success: ' + vm.results);
        }, function(errorMsg) {
          $log.warn('XHR request failed');
          vm.results = errorMsg;
        });

      vm.tableHeaders = ['Name', '', 'DOB', 'Nationality'];

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('GPQuery.core', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ngRoute',
      'ngMaterial',
      'nvd3',
      'toastr'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.core')
    .controller('PageController', PageController);


  /** @ngInject */
  function PageController($mdSidenav) {
    var vm = this;

    vm.navLinks = [];
    vm.toggleSidenav = toggleSidenav;

    activate();

    ////////////////


    // PageController Startup Logic
    // ------------------------------

    function activate() {
      vm.navLinks = ['Results', 'Races', 'Drivers', 'Constructors'];
    }


    // Toggle Sidenav
    // ------------------------------

    function toggleSidenav() {
      $mdSidenav('left').toggle();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('GPQuery.core')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.core')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/races', {
        templateUrl: 'app/dashboard/queries/races/races.html',
        controller: 'RacesController',
        controllerAs: 'vm'
      })
      .when('/results', {
        templateUrl: 'app/dashboard/queries/results/results.html',
        controller: 'ResultsController',
        controllerAs: 'vm'
      })
      .when('/drivers', {
        templateUrl: 'app/dashboard/queries/drivers/drivers.html',
        controller: 'DriversController',
        controllerAs: 'vm'
      })
      .when('/constructors', {
        templateUrl: 'app/dashboard/queries/constructors/constructors.html',
        controller: 'ConstructorsController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/results'
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('GPQuery.core')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.core')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-bottom-left';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

(function() {
  'use strict';

  /**
   * Service for retrieving query mode information
   */
  angular
    .module('GPQuery.core')
    .factory('queryService', queryServiceFactory);

  /** @ngInject */
  function queryServiceFactory($log) {

    var service = {
      getAllQueries:  getAllQueries
    };

    return service;

    ////////////////

    function getAllQueries() {
      return {

      };
    }

  }

})();

(function() {
  'use strict';

  /**
   * Ergast Wrapper for ngResource
   *
   * @param   {String}  url
   * @param   {Object}  paramDefaults
   * @param   {Object}  actions
   * @return  {Object}  service
   * @link    https://docs.angularjs.org/api/ngResource/service/$resource
   */
  angular
    .module('GPQuery.core')
    .factory('ergastService', ergastServiceFactory);

  /** @ngInject */
  function ergastServiceFactory($log, $resource) {


    /**
     * Parameterised Default URL
     *
     * @param {String}      series    'f1' or 'fe'
     * @param {int|String}  season    Year, 1950-present, or 'current'
     * @param {int|String}  round     Round Number, or 'last'
     * @param {String}      resource  Resource Query
     */
    var url = 'http://ergast.com/api/:series/:season/:round/:resource.json';


    /**
     * Default Parameters
     *
     * @param paramDefaults.series    'f1'
     * @param paramDefaults.season    'current'
     * @param paramDefaults.round     'last'
     * @param paramDefaults.resource  'results'
     */
    var paramDefaults = {
      series    : 'f1',
      season    : 'current',
      round     : 'last',
      resource  : 'results'
    };


    /**
     * Custom Resource actions
     *
     * @return  {HttpPromise}
     * @link    https://docs.angularjs.org/api/ng/service/$http#usage
     */
    var actions = {};


    // Get Resource
    // ------------------------------
    actions.getResource = {
      method  : 'GET',
      params  : {resource: '@resource'}
    };


    // Get Driver Standings
    // ------------------------------
    actions.getDriverStandings = {
      method  : 'GET',
      params  : {resource  : 'driverStandings'}
    };


    // Create $resource Object
    // ------------------------------
    var service = $resource(url, paramDefaults, actions);


    // Return Service
    // ------------------------------
    return service;

  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery', [

      'GPQuery.core',
      'GPQuery.components',

      'GPQuery.dashboard'

    ]);

})();

(function() {
  'use strict';

  angular
      .module('GPQuery')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('GPQuery.components', [
    ]);

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.components')
    .directive('gpDataTableCol', gpDataTableColDirective);

  /** @ngInject */
  function gpDataTableColDirective() {
    var directive = {
      restrict: 'E',
      replace: true,
      scope: {
        tableCols: '='
      },
      template: 'app/components/dataTable/dataTableCol.html'
      //link: linkFunc,
    };

    return directive;

    //function linkFunc(scope, el, attr, vm) {
    //  var watcher;
    //  var typist = malarkey(el[0], {
    //    typeSpeed: 40,
    //    deleteSpeed: 40,
    //    pauseDelay: 800,
    //    loop: true,
    //    postfix: ' '
    //  });

    //  el.addClass('acme-malarkey');

    //  angular.forEach(scope.extraValues, function(value) {
    //    typist.type(value).pause().delete();
    //  });

    //  watcher = scope.$watch('vm.contributors', function() {
    //    angular.forEach(vm.contributors, function(contributor) {
    //      typist.type(contributor.login).pause().delete();
    //    });
    //  });

    //  scope.$on('$destroy', function () {
    //    watcher();
    //  });
    //}

  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.components')
    .directive('gpDataTable', gpDataTableDirective);

  /** @ngInject */
  function gpDataTableDirective() {
    var directive = {
      restrict: 'E',
      replace: true,
      scope: {
      },
      template: 'app/components/dataTable/dataTable.html',
      //link: linkFunc,
      controller: 'DataTableController',
      controllerAs: 'vm'
    };

    return directive;

    //function linkFunc(scope, el, attr, vm) {
    //  var watcher;
    //  var typist = malarkey(el[0], {
    //    typeSpeed: 40,
    //    deleteSpeed: 40,
    //    pauseDelay: 800,
    //    loop: true,
    //    postfix: ' '
    //  });

    //  el.addClass('acme-malarkey');

    //  angular.forEach(scope.extraValues, function(value) {
    //    typist.type(value).pause().delete();
    //  });

    //  watcher = scope.$watch('vm.contributors', function() {
    //    angular.forEach(vm.contributors, function(contributor) {
    //      typist.type(contributor.login).pause().delete();
    //    });
    //  });

    //  scope.$on('$destroy', function () {
    //    watcher();
    //  });
    //}

  }

})();

(function() {
  'use strict';

  angular
    .module('GPQuery.components')
    .controller('DataTableController', DataTableController);


  /** @ngInject */
  function DataTableController($log) {
    var vm = this;

    vm.title = 'DataTableController';

    activate();

    ////////////////

    // DataTableController Startup Logic
    // ------------------------------
    function activate() {

    }

  }
})();

angular.module("GPQuery").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/dataTable/dataTable.html","");
$templateCache.put("app/dashboard/queries/races/races.html","<table class=\"table races\" ng-controller=\"RacesController as vm\"><thead><tr><th ng-repeat=\"header in vm.tableHeaders\">{{header}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.resultsRows\"><td>{{ row.round }}</td><td>{{ row.raceName }}</td><td>{{ row.Circuit.circuitName }}</td><td>{{ row.Circuit.Location.locality }}, {{ row.Circuit.Location.country }}</td><td>{{ row.date }}</td><td>{{ row.time }}</td></tr></tbody></table>");
$templateCache.put("app/dashboard/queries/drivers/drivers.html","<table class=\"table races\" ng-controller=\"DriversController as vm\"><thead><tr><th ng-repeat=\"header in vm.tableHeaders\">{{header}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.resultsRows\"><td>{{ row.familyName }}</td><td>{{ row.givenName }}</td><td>{{ row.dateOfBirth }}</td><td>{{ row.nationality }}</td></tr></tbody></table>");
$templateCache.put("app/dashboard/queries/results/results.html","<table class=\"table results\" ng-controller=\"ResultsController as vm\"><thead><tr><th ng-repeat=\"header in vm.tableHeaders\">{{header}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.resultsRows\"><td>{{ row.positionText }}</td><td>{{ row.grid }}</td><td>{{ row.Driver.givenName }} {{ row.Driver.familyName }}</td><td>{{ row.Driver.permanentNumber }}</td><td>{{ row.Driver.nationality }}</td><td>{{ row.Constructor.name }}</td><td>{{ row.laps }}</td><td ng-if=\"row.status !== \'Finished\'\">{{ row.status }}</td><td ng-if=\"row.status === \'Finished\'\">{{ row.Time.time }}</td><td>{{ row.points }}</td></tr></tbody></table>");}]);